!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (window.define)
		define('hotels/nearbyhotels',['libs/ct_view' ], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.View) // CT.settings.nearbyHotelsView
}('nearbyHotelsView', function(View) {
	
	var nearbyhotels = {
		
		events : {
			'click a.fRight' : 'removeNearbyHotels',
			'click button' : 'removeNearbyMessage'
		},
		
		
		
		
		
		
		// shows the nearby message
		init : function() {

			var nearbyHotels = '';
			$.each(CT.searchJson.ncm, function(index, value) {
				if (index != 0)
					nearbyHotels += ', ';
				nearbyHotels += value;
			});
			this.$el.find("span").html(nearbyHotels.replace(/,\s([^,]+)$/, ' and $1'));
			this.$el.show();
		},
		
		
		
		
		
		// removes the near by hotles from json.
		removeNearbyHotels : function() {
			var searchJsonWithOutNch = {
				ht : []
			};
			var removeIds = [];
			var cnt = 0;
			
			$.each(CT.searchJson.ht, function(index, value) {
				if (value.nci != undefined) {
					searchJsonWithOutNch.ht[cnt] = value;
					cnt++;
				}else{
					removeIds.push(value.id);
				}
			});
			
			CT.searchJson.ht = searchJsonWithOutNch.ht;
			this.removeNearbyMessage();
			
			CT.fire('nearbyHotels.ready',[CT.searchJson,removeIds]);
		},
		
		
		
		
		// removes the message
		removeNearbyMessage : function() {
			this.$el.hide();
		}
	};
	
	
	
	
	
	
	CT.subscribe('initnbHotels', function(mObj){
		nearbyhotels.$el = mObj.id;
		var nearbyhotelsView = View(nearbyhotels);
		nearbyhotelsView.init();
	});
	
	
	return nearbyhotels;
}, CT.settings);
